import { createRoot } from "react-dom/client";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCartAddedItems from './Components/MiniCartAddedItems';
import QuickSearch from './Components/QuickSearch';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchClearButtonContainer from './Containers/FacetedSearchClearButton.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import NotificationContainer from './Containers/Notification.container';
import DynamicComponent from './Components/DynamicComponent';
import BackToTopButton from './Components/BackToTopButton';
import ResellerMap from './Components/ResellerMap';
import ResetPasswordContainer from './Components/ResetPassword'
import { get } from '../Scripts/Services/http';
import LiveEditing from './Components/LiveEditing';
import DownloadChargePDFs from "./Components/OrderHistory/DownloadChargePDFs";

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
const store = createStore(
  app,
  preloadState,
  composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
);

// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {};

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
store.injectReducer = (key, asyncReducer) => {
  if (!store.asyncReducers[key]) {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(createReducer(store.asyncReducers));
  }
};

window.__litium = {
  ...window.__litium,
  bootstrapComponents: () => {
    // bootstrap React components, in case the HTML response we receive from the server
    // has React components. ReactDOM.render performs only an update on previous rendered
    // components and only mutate the DOM as necessary to reflect latest React element.
    bootstrapComponents();
  },
  cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
  registeredContainers.push(container);
  const root = createRoot(container);
  root.render(element);
};

/*window.onunload = () => {
  // make sure components are unmounted, redux's listener are unsubscribed
  // to fix issue with iframe navigation in IE
  registeredContainers.forEach((container) => {
    const root = createRoot(container);
    root.unmount();
  });
};*/

const bootstrapComponents = () => {
   if (document.getElementById('liveEditing')) {
        renderReact(
            <Provider store={store}>
                <LiveEditing />
            </Provider>,
            document.getElementById('liveEditing')
        );
    }
  if (document.getElementById('minicart-items')) {
    renderReact(
      <Provider store={store}>
        <MiniCartAddedItems />
      </Provider>,
      document.getElementById('minicart-items')
    );
  }
  if (document.getElementById('quickSearch')) {
    renderReact(
      <Provider store={store}>
        <QuickSearch />
      </Provider>,
      document.getElementById('quickSearch')
    );
  }
  if (document.getElementById('navbar')) {
    renderReact(
      <Provider store={store}>
        <NavigationContainer />
      </Provider>,
      document.getElementById('navbar')
    );
  }
  if (document.getElementById('clearFilterButton')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchClearButtonContainer />
      </Provider>,
      document.getElementById('clearFilterButton')
    );
  }
  if (document.getElementById('facetedSearch')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchContainer />
      </Provider>,
      document.getElementById('facetedSearch')
    );
  }
  if (document.getElementById('facetedSearchCompact')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchCompactContainer />
      </Provider>,
      document.getElementById('facetedSearchCompact')
    );
  }

  if (document.querySelectorAll('form-datepicker').length > 0) {
    const FormDatePicker = DynamicComponent({
      loader: () => import('./Components/FormDatePicker')
    });

    Array.from(document.querySelectorAll('form-datepicker')).forEach((items) => {
      renderReact(<FormDatePicker id={items.dataset.id} label={items.dataset.label} selectedDate={items.dataset.selectedate} placeholder={items.dataset.placeholder} />, items);
    });
  }

  if (document.querySelectorAll('walkthrough-trigger').length > 0) {
    const Walkthrough = DynamicComponent({
      loader: () => import('./Components/Walkthrough/Walkthrough')
    });

    Array.from(document.querySelectorAll('walkthrough-trigger')).forEach((item) => {
      renderReact(<Walkthrough {...item.dataset} />, item);
    });
  }

  if (document.getElementById('globalNotification')) {
    renderReact(
      <Provider store={store}>
        <NotificationContainer />
      </Provider>,
      document.getElementById('globalNotification')
    );
  }

  if (document.getElementById('myPagePersons')) {
    const PersonList = DynamicComponent({
      loader: () => import('./Containers/PersonList.container'),
    });
    renderReact(
      <Provider store={store}>
        <PersonList />
      </Provider>,
      document.getElementById('myPagePersons')
    );
  }
  if (document.getElementById('myPageAddresses')) {
    const AddressList = DynamicComponent({
      loader: () => import('./Containers/AddressList.container'),
    });
    renderReact(
      <Provider store={store}>
        <AddressList />
      </Provider>,
      document.getElementById('myPageAddresses')
    );
  }

  if (document.getElementById('checkout')) {
    const Checkout = DynamicComponent({
      loader: () => import('./Components/Checkout/Checkout'),
    });
    renderReact(
      <Provider store={store}>
        <Checkout />
      </Provider>,
      document.getElementById('checkout')
    );
  }

  if (document.getElementById('placeorder-temp')) {
    const PlaceOrder = DynamicComponent({
      loader: () => import('./Components/Checkout/PlaceOrder'),
    });
    renderReact(
      <Provider store={store}>
        <PlaceOrder />
      </Provider>,
      document.getElementById('placeorder-temp')
    );
  }

  if (document.getElementById('configurator-standalone')) {
    const ConfiguratorStandAlone = DynamicComponent({
      loader: () => import('./Components/Configurator/ConfiguratorStandAlone'),
    });
    const configStandAloneElement = document.getElementById('configurator-standalone');
    const { id, isconfigurable } = configStandAloneElement.dataset;
    renderReact(
      <Provider store={store}>
        <ConfiguratorStandAlone useId={id} isConfigurable={isconfigurable == 'true' ? true : false} />
      </Provider>,
      configStandAloneElement
    );
  }

  else if (document.getElementById('configurator-drawer')?.innerHTML === "") {         
    const ConfiguratorDialog = DynamicComponent({
      loader: () => import('./Components/Configurator/ConfiguratorDialog'),
    });
    const configDialogElement = document.getElementById('configurator-drawer');
    renderReact(
      <Provider store={store}>
        <ConfiguratorDialog />
      </Provider>,
      configDialogElement
    );
  }

  if (document.querySelector('download-pricelist')) {
    const DownloadPriceList = DynamicComponent({
      loader: () => import('./Components/DownloadPricelist'),
    });
    const downloadPricelistElement = document.querySelector('download-pricelist');

    renderReact(
      <Provider store={store}>
        <DownloadPriceList {...downloadPricelistElement.dataset} />
      </Provider>,
      downloadPricelistElement
    );
  }

  if (document.querySelectorAll('.slider').length > 0) {
    const Slider = DynamicComponent({
      loader: () => import('./Components/Slider'),
    });
    Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
      const sliderSettings = {
        autoPlay: (slider.dataset.autoplay == 'True' ? true : false),
        interval: (slider.dataset.numberofseconds != 0 ? slider.dataset.numberofseconds * 1000 : 3000),
      }
      const values = [...slider.querySelectorAll('.slider__block')].map((block) => {
        return {
          image: block.dataset.image,
          url: block.dataset.url,
          text: block.dataset.text,
        };
      });

      if (values.length > 0) {
        renderReact(<Slider values={values} sliderSettings={sliderSettings} />, slider);
      }
    });
  }

  if (document.querySelectorAll('.newsslider').length > 0) {
    const Slider = DynamicComponent({
      loader: () => import('./Components/NewsBlockSlider'),
    });
    Array.from(document.querySelectorAll('.newsslider')).forEach((slider, index) => {
      const { itemstodisplay, urlredirect } = slider.dataset;
      const values = [...slider.querySelectorAll('.newsslider__block')].map((block) => {
        return {
          image: block.dataset.image,
          url: block.dataset.url,
          text: block.dataset.text,
          desc: block.dataset.desc,
          externalUrl: block.dataset.externalurl,
          textColor: block.dataset.textcolor
        };
      });
      if (values.length > 0) {
        renderReact(<Slider values={values} itemstodisplay={itemstodisplay} urlredirect={urlredirect} />, slider);
      }
    });
  }

  if (document.querySelectorAll('triggerconfig-button').length > 0) {
    const TriggerConfigButton = DynamicComponent({
      loader: () => import('./Components/Configurator/TriggerConfiguratorButton'),
    });

    Array.from(document.querySelectorAll('triggerconfig-button')).forEach((button) => {
      const { id, isconfigurable } = button.dataset;

      renderReact(
        <Provider store={store}>
          <TriggerConfigButton id={id} isConfigurable={isconfigurable == 'true' ? true : false} />
        </Provider>,
        button
      );
    });
  }

  if (document.querySelectorAll('organization-list').length > 0) {
    const OrganizationList = DynamicComponent({
      loader: () => import('./Components/OrganizationList'),
    });
    Array.from(document.querySelectorAll('organization-list')).forEach((item) => {
      const { label, selectedorganizationname, redirecturl, selectedorganizationnumber } = item.dataset;

      renderReact(
        <Provider store={store}>
          <OrganizationList {...{
            label,
            selectedOrganizationName: selectedorganizationname,
            selectedOrganizationNumber: selectedorganizationnumber,
            redirectUrl: redirecturl
          }} />
        </Provider>,
        item
      );
    });
  }

  if (document.querySelectorAll('reorder-button').length > 0) {
    const ReorderButton = DynamicComponent({
      loader: () => import('./Containers/ReorderButton.Container'),
    });
    Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
      const { cssClass, orderId, title } = button.dataset;
      const label = button.innerText;
      renderReact(
        <Provider store={store}>
          <ReorderButton {...{ label, title, cssClass, orderId }} />
        </Provider>,
        button
      );
    });
  }
  if (document.querySelectorAll('.favouritesdata').length > 0) {
    const FavouritesContainer = DynamicComponent({
      loader: () => import('./Components/Favourites'),
    });
    Array.from(document.querySelectorAll('.favouritesdata')).forEach((Favourites) => {
      var data = Favourites.dataset;
      renderReact(
        <Provider store={store}>
          <FavouritesContainer {...data} />
        </Provider>,
        Favourites
      );
    });
  }

  if (document.querySelectorAll('deliverydetailsiframe').length > 0) {
    const DeliveryDetailIframe = DynamicComponent({
      loader: () => import('./Containers/DeliveryDetailFrame.container'),
    });
    Array.from(document.querySelectorAll('deliverydetailsiframe')).forEach((item) => {
      const { id, datevalue, url } = item.dataset;
      renderReact(
        <Provider store={store}>
          <DeliveryDetailIframe id={id} datevalue={datevalue} url={url}></DeliveryDetailIframe>
        </Provider>,
        item
      );
    });
  }

  if (document.querySelectorAll('config-stock').length > 0) {
    const Stock = DynamicComponent({
      loader: () => import('./Components/Stock/Stock'),
    });
    let arrayArticleList = [];
    Array.from(document.querySelectorAll('config-stock')).forEach((stock) => {
      const { id } = stock.dataset;
      arrayArticleList.push(id);
    });
    Array.from(document.querySelectorAll('config-stock')).forEach((stock) => {
      const { id, isproductpage } = stock.dataset;
      renderReact(
        <Provider store={store}>
          <Stock {...{ arrayArticleList, id, isProductPage: isproductpage }} />
        </Provider>,
        stock
      );
      arrayArticleList = [];
    });
  }

  if (document.querySelector('search-results')) {
    const QuickSearchResult = DynamicComponent({
      loader: () => import('./Components/QuickSearchResult'),
    });
    renderReact(
      <Provider store={store}>
        <QuickSearchResult />
      </Provider>,
      document.querySelector('search-results')
    );
  }

  if (document.getElementById('playground')) {
    const Playground = DynamicComponent({
      loader: () => import('./Components/CartGrid/Playground'),
    });
    renderReact(
      <Provider store={store}>
        <Playground />
      </Provider>,
      document.getElementById('playground')
    );
  }

  if (document.querySelectorAll('reseller-map').length > 0) {
    Array.from(document.querySelectorAll('reseller-map')).forEach((reseller) => {
      renderReact(
        <Provider store={store}>
          <ResellerMap />
        </Provider>,
        reseller
      );
    });
  }

  if (document.querySelectorAll('#keepalive').length > 0) {
    const rootRoute = '/api/utility/KeepSessionAlive?time=' + Date();
    setInterval(() => get(rootRoute), 250000);
  }

  if (document.querySelectorAll('resetpassword').length > 0) {
    Array.from(document.querySelectorAll('resetpassword')).forEach((resetpassword) => {
      renderReact(
        <Provider store={store}>
          <ResetPasswordContainer />
        </Provider>,
        resetpassword
      );
    });
  }

  if (document.getElementById('backtotop')) {
    renderReact(
      <Provider store={store}>
        <BackToTopButton />
      </Provider>,
      document.getElementById('backtotop')
    );
  }

  if (document.getElementById('signalR')) {
    const SignalR = DynamicComponent({
      loader: () => import('./SignalR'),
    });
    renderReact(
      <Provider store={store}>
        <SignalR />
      </Provider>,
      document.getElementById('signalR')
    );
  }


  if (document.querySelectorAll('.saved-cart-list').length > 0) {
    const SavedCart = DynamicComponent({
      loader: () => import('./Components/SavedCart/SavedCart'),
    });

    Array.from(document.querySelectorAll('.saved-cart-list')).forEach((savedCart) => {
      renderReact(
        <Provider store={store}>
          <SavedCart />
        </Provider>,
        savedCart
      );
    });
  }

  //if (document.querySelectorAll('.order-history-details-checkbox').length > 0) {
  //  const OrderHistoryDetailsCheckBox = DynamicComponent({
  //    loader: () =>
  //      import('./Components/OrderHistory/OrderHistoryDetailsCheckBox'),
  //  });

  //  Array.from(document.querySelectorAll('.order-history-details-checkbox')).forEach(
  //    (orderHistoryDetailsCheckBox) => {
  //      const { id, disable } = orderHistoryDetailsCheckBox.dataset;
  //      ReactDOM.createRoot(
  //        <Provider store={store}>
  //          <OrderHistoryDetailsCheckBox id={id} disable={disable === 'True'} />
  //        </Provider>,
  //        orderHistoryDetailsCheckBox
  //      );
  //    }
  //  );
  //}

  if (document.getElementById('downloadChargePdfs')) {    
    const downloadElem = document.getElementById('downloadChargePdfs');
    const { pdfs, orderid } = downloadElem.dataset;
    renderReact(
      <Provider store={store}>
        <DownloadChargePDFs pdfs={pdfs} orderId={orderid} />
      </Provider>,
      document.getElementById('downloadChargePdfs')
    );
  }

  if (document.getElementById('orderHistoryAddToCart')) {
    const AddToCart = DynamicComponent({
      loader: () =>
        import('./Components/OrderHistory/OrderHistoryDetailsAddToCart'),
    });
    const orderHistoryAddToCart = document.getElementById(
      'orderHistoryAddToCart'
    );
    const { orderid } = orderHistoryAddToCart.dataset;
    ReactDOM.createRoot(
      <Provider store={store}>
        <AddToCart orderId={orderid} />
      </Provider>,
      orderHistoryAddToCart
    );
  }

    if (document.getElementById('translate-to-english-checkbox')) {
    const TranslateToEnglishCheckBox = DynamicComponent({
      loader: () => import('./Components/TranslateToEnglishCheckBox'),
    });
    const translateToEnglishCheckBox = document.getElementById('translate-to-english-checkbox');
    const { selected } = translateToEnglishCheckBox.dataset;
    renderReact(
      <Provider store={store}>
        <TranslateToEnglishCheckBox selected={selected.toLowerCase() == 'true' ? true : false} />
      </Provider>,
      translateToEnglishCheckBox
    );
  }

  if (document.getElementById('headerAddToCart')) {
    const HeaderAddToCart = DynamicComponent({
      loader: () =>
        import('./Components/QuickAddToCart'),
    });
    const headerAddToCart = document.getElementById(
      'headerAddToCart'
    );
    
    renderReact(
      <Provider store={store}>
        <HeaderAddToCart />
      </Provider>,
      headerAddToCart
    );
  }



};
bootstrapComponents();